module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_5_6_2.44f6ede1.jpeg";